module.exports = __webpack_public_path__ + "static/media/oxford.d703e89e.png";